export default {
    intro: `Chữ cơ bản là yếu tố nhỏ nhất tạo nên từ.<br />
            Hãy cùng tìm hiểu mối quan hệ giữa từ được tạo từ Chữ cơ bản và các chữ cái nhé. `,
    options: { textbook: 'Từ trong sách giáo khoa', page: 'Sách giáo khoa' },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `Chữ ${round === 1 ? 'thứ nhất' : 'thứ hai'}`;
        },
        title: {
            word: 'Chữ', example1: 'Ví dụ từ 1', example2: 'Ví dụ từ 2',
            check: 'Kiểm tra từ đã học', question: 'Câu hỏi từ vựng',
            meaning: 'Kiểm tra mối quan hệ ý nghĩa', meaningQuestion: 'Câu hỏi quan hệ ý nghĩa',
        },
    },
    indicator: {
        word: 'Học hình dạng, âm thanh và ý nghĩa của Chữ cơ bản.',
        example1: 'Học hai từ có chứa Chữ cơ bản.',
        example2: 'Học cách Chữ cơ bản được sử dụng trong từ.',
        question: 'Trong hai từ, từ nào sử dụng chữ "{ reading }"?',
        meaning: 'Học cách Chữ cơ bản được sử dụng trong từ.',
        meaningQuestion: 'Mối quan hệ ý nghĩa giữa hai Chữ cơ bản là gì?',
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher
                ? 'Đây là phần Học sinh tự xoay khối lập phương để học.'
                : 'Hãy tự xoay khối lập phương để học chữ cái nhé.';
        },
    },
    result: { correct: 'Đúng', incorrect: 'Sai', selected: 'Đã chọn' },
    buttons: { next: 'Tiếp theo' },
    study: {
        example: 'Câu ví dụ',
        meaning: 'Nghĩa',
    },
};
